exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa1Arrival/wa1012/wa1012.component.css
// module id = ../../../../../src/app/pages/wa1Arrival/wa1012/wa1012.component.css
// module chunks = main